import Image from "@Components/Image";
import CustomLink from "@Components/CustomLink";
import Reveal from "@Components/Reveal/Reveal";
import styles from "./ListWithUsCta.module.scss";
import wrapperHOC from "@Utils/wrapperHOC";
import useTranslationHook from "hooks/useTranslationHook";
import { LEADS_LIST } from "constants/configConstants";
import { pageAsset } from "@Utils/getStaticAssetPath";

// Images come from the static-assets bucket, never `import`ed — see `pageAsset`.
const asset = pageAsset("ListWithUsV2");

const ctaImg = asset("cta-city.jpg");

/**
 * Closing CTA card — Figma node 2456:6713.
 *
 * Three stacked layers over the photo, all from the node: a flat tint, a
 * left-to-right scrim that holds the copy side dark, and a bottom-up scrim over
 * the lower 190px. The copy block is bottom-left aligned inside 56px padding.
 */
interface CtaProps {
  /** Opens the listing form. The page owns the modal; this only asks for it. */
  onListClick: () => void;
}

const Cta = ({ onListClick }: CtaProps) => {
  const { t } = useTranslationHook();

  return (
    <section className={styles.section}>
      <div className={styles.card}>
        <Image src={ctaImg} alt="" className={styles.image} width="100%" height="100%" />

        <span className={styles.tint} aria-hidden="true" />
        <span className={styles.scrim} aria-hidden="true" />
        <span className={styles.scrimBottom} aria-hidden="true" />

        <div className={styles.content}>
          <Reveal className={styles.block}>
            <div className={styles.text}>
              {/* ONE LINE now, and the `<br />` that split the old two-line heading is gone with
                it — a manual break under a single short line would just add an empty row.

                It replaced "Fill the form in minutes. / amber takes it from there.", which had
                gone stale: the Steps section above no longer has a "fill the form" step at all
                (it reads Signup with us / We set you up / You get booked), so this was the last
                place on the page still describing a form. */}
              <h2 className={styles.heading}>{t("list.v2.cta.heading")}</h2>
              <p className={styles.sub}>{t("list.v2.cta.sub")}</p>
            </div>

            <CustomLink
              href={LEADS_LIST}
              onClick={(e: React.MouseEvent) => {
                e.preventDefault();
                onListClick();
              }}
              className={styles.button}
              dataTestId="list-with-us-cta"
            >
              {t("list.v2.cta.liston")}
            </CustomLink>
          </Reveal>
        </div>
      </div>
    </section>
  );
};

export default wrapperHOC(Cta, {
  componentName: "Cta-ListWithUs",
  showForChina: true,
});
